<ng-container *ngIf="toasts.length">
    <div class="gt-toast" [ngClass]="positionClasses">
        <div *ngFor="let toast of toasts">
            <alert [type]="toast.type"
                   [dismissible]="dismissible"
                   [dismissOnTimeout]="toast.timeout"
                   (onClosed)="onClosed(toast)">
                {{ toast.message }}
            </alert>
        </div>
    </div>
</ng-container>
